module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "viewer"
    }
  }, [_c('header-nav'), _vm._v(" "), _c('main', {
    staticClass: "main fix"
  }, [_c('transition', [_c('keep-alive', [_c('router-view')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5018cce3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Viewer.vue
// module id = 125
// module chunks = 2